import { BsArrowLeft } from "react-icons/bs";
import { Link, useLocation } from "react-router-dom";

const GoBackButton = ({ handleAction, link }) => {
    return (
        <Link
            className="no-underline text-gray-500"
            to={{
                pathname: link,
                state: "backUrl"
            }}>
            <div
                onClick={() => handleAction()}
                className="flex items-center cursor-pointer mb-2">
                <BsArrowLeft size={18} />
                <span className="ml-2 text-sm">Go Back</span>
            </div>
        </Link>
    )
}

export default GoBackButton;